import ContextProvider from "./store/ContextProvider";
import Layout from "./Layout";

const App = () => {
  return (
    <ContextProvider>
      <Layout />
    </ContextProvider>
  );
};

export default App;
